import { default as _91_46_46_46slug_93rNdsAR3YBGMeta } from "/builds/common/careers/careers-static/pages/[...slug].vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93rNdsAR3YBGMeta?.name ?? "slug",
    path: _91_46_46_46slug_93rNdsAR3YBGMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93rNdsAR3YBGMeta || {},
    alias: _91_46_46_46slug_93rNdsAR3YBGMeta?.alias || [],
    redirect: _91_46_46_46slug_93rNdsAR3YBGMeta?.redirect || undefined,
    component: () => import("/builds/common/careers/careers-static/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93rNdsAR3YBGMeta?.name ?? "slug___en",
    path: _91_46_46_46slug_93rNdsAR3YBGMeta?.path ?? "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93rNdsAR3YBGMeta || {},
    alias: _91_46_46_46slug_93rNdsAR3YBGMeta?.alias || [],
    redirect: _91_46_46_46slug_93rNdsAR3YBGMeta?.redirect || undefined,
    component: () => import("/builds/common/careers/careers-static/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93rNdsAR3YBGMeta?.name ?? "slug___lv",
    path: _91_46_46_46slug_93rNdsAR3YBGMeta?.path ?? "/lv/:slug(.*)*",
    meta: _91_46_46_46slug_93rNdsAR3YBGMeta || {},
    alias: _91_46_46_46slug_93rNdsAR3YBGMeta?.alias || [],
    redirect: _91_46_46_46slug_93rNdsAR3YBGMeta?.redirect || undefined,
    component: () => import("/builds/common/careers/careers-static/pages/[...slug].vue").then(m => m.default || m)
  }
]